import {
  Mail,
  Phone,
  MapPin,
  Github,
  Linkedin,
  Twitter,
  Facebook,
  ArrowUp,
} from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import CalculadorTiempo from "./internos/CalculadorTiempo";
import ColaborarModal from "./internos/ColaborarModal";
const Footer = ({ scrollToSection }) => {
  const currentYear = new Date().getFullYear();
  const { language, translations } = useLanguage();
  const footer = translations[language].footer;
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white relative">
      <div className="h-1 bg-gradient-to-r from-[#12A9B0] via-purple-600 to-[#12A9B0]"></div>

      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="space-y-4">
            <div
              className="flex items-center gap-3 group cursor-pointer"
              onClick={() => scrollToSection("inicio")}
            >
              <img
                src="/images/logom.svg"
                alt="Heuristiko Logo"
                className="h-10 w-auto md:h-12 object-contain transition-transform duration-300 group-hover:scale-110"
              />
              <div>
                <h1 className="text-xl font-bold">{footer.empresa.nombre}</h1>
                <p className="text-xs tracking-widest text-gray-400">
                  {footer.empresa.slogan}
                </p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              {footer.empresa.descripcion}
            </p>

            <div className="flex gap-3 pt-4">
              {footer.redesSociales.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="p-2 bg-gray-800 rounded-lg hover:bg-[#12A9B0] transition-all duration-300 hover:scale-110"
                >
                  {/* Iconos se mantienen igual */}
                  {social.label === "GitHub" && <Github size={20} />}
                  {social.label === "LinkedIn" && <Linkedin size={20} />}
                  {social.label === "Twitter" && <Twitter size={20} />}
                  {social.label === "Facebook" && <Facebook size={20} />}
                </a>
              ))}
            </div>
            <div className="flex gap-3 pt-4">
              <CalculadorTiempo />
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-lg flex items-center gap-2">
              {footer.secciones.enlacesRapidos}
              <span className="h-px bg-[#12A9B0] flex-1 max-w-[50px]"></span>
            </h4>
            <ul className="space-y-3">
              {footer.enlaces.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-[#12A9B0] transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="w-0 h-px bg-[#12A9B0] group-hover:w-4 transition-all duration-300"></span>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-lg flex items-center gap-2">
              {footer.secciones.servicios}
              <span className="h-px bg-[#12A9B0] flex-1 max-w-[50px]"></span>
            </h4>
            <ul className="space-y-3">
              {footer.servicios.map((service, index) => (
                <li
                  key={index}
                  className="text-gray-400 flex items-center gap-2"
                >
                  <span className="w-1.5 h-1.5 bg-[#12A9B0] rounded-full"></span>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-lg flex items-center gap-2">
              {footer.secciones.contacto}
              <span className="h-px bg-[#12A9B0] flex-1 max-w-[50px]"></span>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${footer.infoContacto.email}`}
                  className="text-gray-400 hover:text-[#12A9B0] transition-colors duration-300 flex items-center gap-2"
                >
                  <span className="text-[#12A9B0]">
                    <Mail size={16} />
                  </span>
                  {footer.infoContacto.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${footer.infoContacto.telefono.replace(
                    /\s/g,
                    ""
                  )}`}
                  className="text-gray-400 hover:text-[#12A9B0] transition-colors duration-300 flex items-center gap-2"
                >
                  <span className="text-[#12A9B0]">
                    <Phone size={16} />
                  </span>
                  {footer.infoContacto.telefono}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#12A9B0] transition-colors duration-300 flex items-center gap-2"
                >
                  <span className="text-[#12A9B0]">
                    <MapPin size={16} />
                  </span>
                  {footer.infoContacto.direccion}
                </a>
              </li>
            </ul>
            <ColaborarModal />
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                {footer.legal.derechosReservados.replace("{year}", currentYear)}
              </p>
              <p className="text-gray-500 text-xs mt-1">
                {footer.legal.desarrolladoCon}
              </p>
            </div>

            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-[#12A9B0] transition-colors">
                {footer.legal.politicaPrivacidad}
              </a>
              <a href="#" className="hover:text-[#12A9B0] transition-colors">
                {footer.legal.terminosUso}
              </a>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToTop}
        className="absolute bottom-8 right-8 p-3 bg-[#12A9B0] rounded-full hover:bg-[#0e8d92] transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label={footer.botones.volverArriba}
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
